import PropTypes from 'prop-types';
import React from 'react';

import withModifier from '../../twig-extensions/filter/withModifier';

const Text = ({ className, modifiers, children, html, tag }) => {
  const Tag = tag;

  if (html) {
    return <Tag className={`text ${className} ${withModifier('text', modifiers)}`} dangerouslySetInnerHTML={{ __html: html }} />;
  }

  return <Tag className={`text ${className} ${withModifier('text', modifiers)}`}>{children}</Tag>;
};

Text.propTypes = {
  className: PropTypes.string,
  modifiers: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.number]),
  html: PropTypes.string,
  tag: PropTypes.oneOf(['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h5', 'h6', 'span', 'figcaption', 'cite', 'label', 'legend', 'small', 'div'])
};

Text.defaultProps = {
  className: '',
  modifiers: [],
  children: null,
  html: null,
  tag: 'p'
};

export default Text;
